export function findDeepInvalid(vNode, path = []) {
    if (!vNode || typeof vNode !== 'object') return null;

    const hasChildren = Object.keys(vNode).some(
        key => key[0] !== '$' && typeof vNode[key] === 'object'
    );

    if (vNode.$invalid && vNode.$dirty && !hasChildren) {
        return path.at(-1);
    }

    for (const key in vNode) {
        if (key[0] !== '$') {
            const result = findDeepInvalid(vNode[key], [...path, key]);
            if (result) return result;
        }
    }

    return null;
}
